import { ReactNode } from "react";
import { Stack } from "@mui/material";
import styles from "./Cooperations.shared.module.scss";
import IntroAnchor from "@/app/features/shared/__to_be_integrated/ui/IntroAnchor";

export function CooperationPartnersListFrame({ children }: { children: ReactNode }) {
    return (
        <>
            <IntroAnchor />
            <Stack className={styles.cooperationsList} spacing={4}>
                {children}
            </Stack>
        </>
    )
}
